<template>
    <div class="onboarding-order-preferences padded">
        <a class='order-preference-scroll-point'></a>
        <p class="page-number">{{ pageNumber }}/9</p>
        <h1 class="onboarding-heading">{{ heading }}</h1>
        <div class="preference-question-cards-wrapper" ref="cardWrapper">
            <div v-for="(option, i) in orderOptions" ref="questionCard">
                <div class="preference-question-card" :class="isSubscription === option.subscribe ? 'card-selected' : ''" @click="onOrderOptionSelected(option.subscribe, i)">
                    <h1 class="option-name">{{ option.text }}</h1>
                </div>
                <p>{{ option.note }}</p>
            </div>
        </div>

        <transition name="fade-fast" mode="out-in">
            <div v-if="isSubscription !== undefined">
                <h4 class="select-label">Grind Preference</h4>
                <select v-model="grindSelected">
                    <option v-for="grind in grindOptions" :value="grind.value">{{ grind.text }}</option>
                </select>

                <h4 class="select-label">Coffee Type</h4>
                <select v-model="typeSelected">
                    <option v-for="type in typeOptions" :value="type.value">{{ type.text }}</option>
                </select>
                <h4 class="select-label">Select Size Category</h4>
                <select v-model="categorySelected" v-on:change="changeCategory" :disabled="changingCategory">
                    <option v-for="category in categories" :value="category.value">
                        <p>{{ category.text }}</p>
                    </option>
                </select>
                <div v-if="categorySelected==='small_size'" class="small-size" id="small-size">
                    <div v-for="size in smallSizes" >
                        <label class="form-check-label" v-bind:for='size' >{{ size }}
                            <input type="checkbox" v-bind:id='size' @click="getSize(size)" :disabled="changingCategory"/>
                        </label>
                    </div>
                </div>
                <div v-if="categorySelected==='medium_size'" class="small-size" id="medium-size">
                    <div v-for="size in mediumSizes">
                        <label class="form-check-label" v-bind:for='size' >{{ size }}
                            <input type="checkbox" v-bind:id='size' @click="getSize(size)" :disabled="changingCategory"/>
                        </label>
                    </div>
                </div>
                <div v-if="categorySelected==='large_size'" class="small-size" id="large-size">
                    <div v-for="size in largeSizes">
                        <label class="form-check-label" v-bind:for='size' >{{ size }}
                            <input type="checkbox" v-bind:id='size' @click="getSize(size)" :disabled="changingCategory"/>
                        </label>
                    </div>
                </div>

                <template v-if="isSubscription">
                    <h4 class="select-label">Frequency</h4>
                    <select v-model="frequencySelected" v-on:change="averageMonthlyCost">
                        <option v-for="frequency in frequencyOptions" :value="frequency.value">{{ frequency.text }}</option>
                    </select>
                </template>

                <template v-if="isSubscription">
                    <h4 class="select-label"></h4>
                    <select v-model="averageCost" v-on:click="changeCostType">
                        <option v-for="avgcost in averageCostOptions" :value="avgcost.value">
                            {{ avgcost.text }}
                        </option>
                    </select>
                    <div v-if="avgCount > 0 && averageCost != 'monthly_cost'">
                        <h3 class="font-green margin-top-xs">{{ avgOrdeCost }}</h3>
                    </div>
                    <div v-if="averageCost === 'monthly_cost'">
                        <h3 class="font-green margin-top-xs">{{ avgMonthlyCost }}</h3>
                    </div>
                </template>

                <p v-if="isSubscription" class="submit-button-note"><b>Half off on your 1st order.</b><span>And we won't play any slick tricks like baiting you, then making you pre-pay for future orders.</span></p>
                
                <div v-if="!isSubscription">
                    <p v-if="categorySelected === 'small_size'" class="submit-button-note">$5 off your first order!</p>
                    <p v-if="categorySelected === 'medium_size'" class="submit-button-note">$10 off your first order!</p>
                    <p v-if="categorySelected === 'large_size'" class="submit-button-note">$20 off your first order!</p>
                </div>
                <div v-if="selectSize.length === 0">
                    <div class="onboarding-button" :class="submitted ? 'btn-disabled' : ''">Show Me My Coffee!</div>
                </div>
                <div v-else>
                    <div class="onboarding-submit-button" @click="submit()" :class="submitted ? 'btn-disabled' : ''">Show Me My Coffee!</div>
                </div>
            </div>
        </transition>

        <div class="preference-question-tip">
            <img class="question-tip-icon" :src="require('home/onboarding/light-bulb-icon.png')" alt="Onboarding Question">
            <template v-if="isSubscription === undefined">
                We won't try to bait you into subscribing.<br>Everyone enjoys our very best price and free shipping on all orders!
            </template>
            <template v-else-if="isSubscription">
                Pause, cancel or edit your subscription anytime.
            </template>
            <template v-else>
                Use our suggestions as a guide or order whatever you want whenever you want it.
            </template>
            <br>
            Never pay for shipping!
        </div>
    </div>
</template>

<script>
    import AnimationMixin from '../../../mixins/animation';

    export default {
        props: {
            pageNumber: undefined,
            options: Array,
            tip: String,
            customSizes: Array,
            avgCosts: Array,
            avgDecafCosts: Array
        },
        mixins: [
            AnimationMixin
        ],
        data: function() {
            return  {
                AVG_PRICE_12OZ: 17,
                AVG_PRICE_5LB: 82,

                isSubscription: undefined,
                submitted: false,

                orderOptions: [
                    { text: 'Set & Forget', subscribe: true, note: 'Subscription' },
                    { text: 'A La Carte', subscribe: false, note: 'Order when I want' }
                ],

                grindSelected: undefined,
                grindOptions: [
                    { text: 'Whole Bean', value: 'whole_bean'},
                    { text: 'Coarse Grind', value: 'course'},
                    { text: 'Medium Grind', value: 'medium'},
                    { text: 'Fine Grind', value: 'fine'},
                ],
                typeSelected: undefined,
                typeOptions: [
                    { text: 'Regular', value: 'regular'},
                    { text: 'Decaf', value: 'decaf'},
                ],
                categorySelected: undefined,
                changingCategory: false,
                categories:[
                    { text: "Small Bag Sizes", value: 'small_size'},
                    { text: "Medium Bag Sizes", value: 'medium_size'},
                    { text: "Large Bag Size", value: 'large_size'}
                ],
                frequencySelected: undefined,
                frequencyOptions: [
                    { text: 'Every 3 Days', value: 'every 3 days'},
                    { text: 'Every 5 Days', value: 'every 5 days'},
                    { text: 'Every Week', value: 'every week'},
                    { text: 'Every 10 Days', value: 'every 10 days'},
                    { text: 'Every 2 Weeks', value: 'every 2 weeks'},
                    { text: 'Every Month', value: 'every month'}
                ],
                averageCost: undefined,
                averageCostOptions: [
                    { text: 'Avg Order Cost', value: 'order_cost'},
                    { text: 'Avg Monthly Cost', value: 'monthly_cost'}
                ],
                animationTimeLine: undefined,
                selectSize: [],
                smallSizes: [],
                mediumSizes: [],
                largeSizes: [],
                newCategory:"",
                avgMonthlyCost: undefined,
                avgOrdeCost: undefined,
                avgCount: 0
            }
        },
        methods: {
            onOrderOptionSelected(isOn, index) {
                if (this.isSubscription === undefined) {
                    this.isSubscription = isOn;
                    this.animationTimeLine = this.createTimeLineForOnboardingQuiz(this.$refs.questionCard, this.$refs.cardWrapper, index, .6);
                    this.animationTimeLine.play();
                    this.scrollDown();
                    this.bagSizes;
                } else {
                    this.isSubscription = undefined;
                    this.reset();
                    if (Array.isArray(this.animationTimeLine) || (typeof this.animationTimeLine) == 'object' ) {
                        this.animationTimeLine.reverse();
                    }
                    this.categorySelected = "small_size";
                    this.parentProperty();
                }

            },
            scrollDown() {
                const elem = this.$el.getElementsByClassName('preference-question-cards-wrapper')[0];

                setTimeout(() => elem.scrollIntoView({behavior: 'smooth'}), 1000);
                setTimeout(() => {this.checkedDefault()}, 100);
            },
            submit() {
                if (this.submitted) {
                    return;
                }

                this.submitted = true;
                const preferences = {
                    grind: this.grindSelected,
                    type: this.typeSelected,
                    size: this.selectSize,
                    frequency: this.isSubscription ? this.frequencySelected : null,
                    subscribe: this.isSubscription,
                    sizecategory: this.categorySelected
                };

                if (!!this.grindSelected && !!this.typeSelected && !!this.selectSize && (!!this.frequencySelected || this.isSubscription === false)) {
                    this.$emit('submit', preferences);
                } else {
                    console.error('Invalid params: ',preferences);
                }
            },
            reset() {
                if (this.submitted) {
                    this.$emit('reset');
                    this.submitted = false;
                }
            },
            getSize(size){
                this.selectSize.push(size);

                if (this.selectSize.filter((item, index) => this.selectSize.indexOf(item) !== index).length > 0){
                    for(let i=0; i<this.selectSize.length; i++){
                        if(this.selectSize[i] == size){
                            delete this.selectSize[i];
                        }
                    }
                }

                this.selectSize = this.selectSize.filter(r => r != undefined);
                this.selectSize = this.selectSize.sort(function(a, b){return parseFloat(a) - parseFloat(b)});

                if(this.selectSize.length == 0){
                    this.selectSize.push(size);
                    document.getElementById(size).checked = true;
                }
                this.averageMonthlyCost;
            },
            changeCategory(){

                this.changingCategory = true;
                this.selectSize = [];

                if (this.categorySelected == "small_size"){
                    this.frequencySelected = this.frequencyOptions[2].value;
                } else if(this.categorySelected === "medium_size"){
                    this.frequencySelected = this.frequencyOptions[4].value;
                } else if(this.categorySelected === "large_size"){
                    this.frequencySelected = this.frequencyOptions[5].value;
                }

                setTimeout(() => { // simulate async operation delay
                  if (this.categorySelected === "small_size") {
                      this.checkedDefault();
                  } else if (this.categorySelected === "medium_size") {
                      this.checkedMedium();
                  } else if (this.categorySelected === "large_size") {
                      this.checkedlarge();
                  }
                  this.changingCategory = false;
                }, 100);
            },
            checkedDefault() {
                var s_size = this.customSizes.filter(r=> r.size_category === "small_size" );
                s_size = s_size.filter(r=> r.imperial_uom != "6oz");
                if (this.isSubscription){
                    s_size = s_size.filter(r=> r.imperial_uom != "16oz");
                }
                var defaultValue = s_size.filter(r=> r.imperial_uom != "8oz").map(r=> r.imperial_uom).sort(function(a, b){return parseFloat(a) - parseFloat(b)});
                this.selectSize = defaultValue;

                for (let i=0; i<defaultValue.length; i++){
                    let element = document.getElementById(defaultValue[i]);
                    if (element && element !== undefined) {
                        element.checked = true;
                    }
                }
                this.averageMonthlyCost
            },
            checkedMedium() {
                var defaultValue = this.customSizes.filter(r=> r.size_category === "medium_size").map(r=> r.imperial_uom).sort(function(a, b){return parseFloat(a) - parseFloat(b)});
                this.selectSize = defaultValue;

                for (let i=0; i<defaultValue.length; i++){
                    let element = document.getElementById(defaultValue[i]);
                    if (element && element !== undefined) {
                        element.checked = true;
                    }
                }
                this.averageMonthlyCost
            },
            checkedlarge() {
                var defaultValue = this.customSizes.filter(r=> r.size_category === "large_size").map(r=> r.imperial_uom).sort(function(a, b){return parseFloat(a) - parseFloat(b)});
                this.selectSize = defaultValue;

                for (let i=0; i<defaultValue.length; i++){
                    let element = document.getElementById(defaultValue[i]);
                    if (element && element !== undefined) {
                        element.checked = true;
                    }
                }
                this.averageMonthlyCost
            },
            changeCostType(){
                if (this.averageCost === "order_cost"){
                    this.avgCount = this.avgCount+1;
                }
            },
            parentProperty(){
                this.$parent.showval = false;
                this.$parent.min=0;
                this.$parent.max=0;
            }
        },
        computed: {
            heading() {
              return this.isSubscription ? 'Subscription Details' : 'Order Preferences';
            },
            averageMonthlyCost() {
                var coffeePrice = 0;
                var sizes = [];

                if (this.typeSelected === "regular"){
                    for (let i=0; i<this.selectSize.length; i++){
                        coffeePrice += this.avgCosts.filter(r=> r.id==this.selectSize[i]).map(n=> n.val)[0];
                        sizes.push(this.avgCosts.filter(r=> r.val != 0 && r.id == this.selectSize[i]).map(n=> n.id)[0]);
                    }
                }else{
                    for (let i=0; i<this.selectSize.length; i++){
                        coffeePrice += this.avgDecafCosts.filter(r=> r.id==this.selectSize[i]).map(n=> n.val)[0];
                        sizes.push(this.avgDecafCosts.filter(r=> r.val != 0 && r.id == this.selectSize[i]).map(n=> n.id)[0]);
                    }
                }
                sizes = sizes.filter(r => r != undefined);
                coffeePrice = coffeePrice != 0 ? (coffeePrice / sizes.length) : 0;
                
                let numOrdersPerMonth = 0;
                if (this.frequencySelected === this.frequencyOptions[0].value)      // 3days
                    numOrdersPerMonth = 10;
                else if (this.frequencySelected === this.frequencyOptions[1].value) // 5days
                    numOrdersPerMonth = 6;
                else if (this.frequencySelected === this.frequencyOptions[2].value) // 1 week
                    numOrdersPerMonth = 4;
                else if (this.frequencySelected === this.frequencyOptions[3].value) // 10 days
                    numOrdersPerMonth = 3;
                else if (this.frequencySelected === this.frequencyOptions[4].value) // 2 weeks
                    numOrdersPerMonth = 2;
                else
                    numOrdersPerMonth = 1; // 1 month

                this.avgOrdeCost = coffeePrice != 0 ? "$"+Math.round(coffeePrice) : "Please select another size";
                this.avgMonthlyCost = coffeePrice != 0 ? "$"+Math.round(coffeePrice * numOrdersPerMonth) : "Please select another size ";
            },
            bagSizes(){
                var s_size = this.customSizes.filter(r=> r.size_category === "small_size" );
                s_size = s_size.filter(r=> r.imperial_uom != "6oz");
                if (this.isSubscription){
                    s_size = s_size.filter(r=> r.imperial_uom != "16oz");
                }
                this.smallSizes = s_size.filter(r=> r.imperial_uom != "8oz").map(r=> r.imperial_uom).sort(function(a, b){return parseFloat(a) - parseFloat(b)});
                this.mediumSizes = this.customSizes.filter(r=> r.size_category === "medium_size").map(r=> r.imperial_uom).sort(function(a, b){return parseFloat(a) - parseFloat(b)});
                this.largeSizes = this.customSizes.filter(r=> r.size_category === "large_size").map(r=> r.imperial_uom).sort(function(a, b){return parseFloat(a) - parseFloat(b)});
                this.categorySelected = "small_size";
                this.averageCost = "order_cost"
            }
        },
        watch: {
            grindSelected: function() {
                this.reset();
            },
            typeSelected: function() {
                this.reset();
            },
            espressoSelected: function() {
                this.reset();
            },
            selectSize: function() {
                this.reset();
                this.avgCount = 0;
            },
            categorySelected: function(){
                this.reset();
                this.parentProperty();
            },
            frequencySelected: function() {
                this.reset();
            }

        },
        mounted() {
            this.grindSelected = this.grindOptions[0].value;
            this.typeSelected = this.typeOptions[0].value;
            this.frequencySelected = this.frequencyOptions[2].value; 
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../../styles/_variables_home.scss";
    @import "../../../styles/common_home.scss";
    @import "../../../styles/form_home.scss";

    .onboarding-order-preferences {
        max-width: 1000px;
        margin: auto;
        padding-top: 3rem;
        text-align: center;
        position: relative;
    }
    .order-preference-scroll-point {
        position: absolute;
        top: -220px;
    }
    .page-number {
        margin-bottom: 0;
    }
    .onboarding-heading {
        margin: 0 2rem .5rem 2rem;
        letter-spacing: -1px;
    }
    .select-label {
        margin-bottom: .5rem;
    }
    .preference-question-cards-wrapper {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-around;
    }
    .preference-question-card {
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 20vw;
        height: 20vw;
        max-width: 200px;
        max-height: 200px;
        min-width: 130px;
        min-height: 130px;
        margin-top: 2rem;
        margin-bottom: 1rem;
        border: 2px solid $color-primary;
        border-radius: 12%;
        cursor: pointer;
        transition: 1s;
        &:hover {
            font-weight: bold;
        }
        h1 {
            margin: 0;
        }
    }
    .card-selected {
        background-color: $color-primary;
        h1 {
            color: $white;
        }
    }
    select {
        width: 250px;
        height: 40px;
        text-align-last: center;
    }
    .submit-button-note {
        color: $green-primary;
        margin-top: 1.5rem;
        margin-bottom: .5rem;
    }
    .onboarding-submit-button {
        @extend .btn-green-lg;
        line-height: 5rem;
        margin: auto;
        animation: animate 3s linear infinite;
    }
    .onboarding-button {
        @extend .btn-green-lg;
        background-color: #50784f4d;
        line-height: 5rem;
        margin: auto;
    }
    .onboarding-button:hover {
        background-color: #50784f4d;
        box-shadow:unset;
    }
    .preference-question-tip {
        width: 400px;
        margin: 4rem auto;
        padding: 2rem;
        border: 1px solid $color-primary;
        border-radius: 11px;
        position: relative;

    }
    .question-tip-icon {
        width: 30px;
        height: 30px;
        position: absolute;
        top: -15px;
        left: 211px;
    }

    .small-size {
        padding: 15px;
        max-width: 210px;
        margin: 0 auto;
        display: flex;
        flex-flow: wrap;
        grid-gap: 15px;
        border: 1px solid #465f87;
        border-radius: 8px;
        margin-top: 20px;
    }

    .small-size >div {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        flex-basis: calc(50% - 10px);
        grid-gap: 15px;
    }

    .small-size >div label {
        height: unset !important;
        line-height: 1.6;
    }
    .small-size {
        padding: 15px;
        max-width: 210px;
        margin: 0 auto;
        display: flex;
        flex-flow: wrap;
        grid-gap: 10px;
        border: 1px solid #465f87;
        border-radius: 8px;
        margin-top: 20px;
    }

    .small-size >div {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        flex-basis: calc(50% - 10px);
        grid-gap: 10px;
        max-width: calc(50% - 10px);
    }
    .small-size > div label span {
        width: auto;
        padding-left: 5px;
    }
    .small-size >div label {
        height: unset !important;
        line-height: 1.6;
        margin-bottom: 0px;
    }
    .form-check-label {
        position: relative;
        padding-left: 18px;
        cursor: pointer;
        color: #3D547C;
        font-size: 15px;
        font-weight: 500;
    }
    .form-check-label input {
        position: absolute;
        cursor: pointer;
        left: 0;
        top: 6px;
    }
    p.submit-button-note span {
        display: block;
        font-size: 14px;
        margin-bottom: 20px;
    }

    @keyframes animate{
        0%{
         background-color: #50784fa6;
        }
        50%{
        background-color: #50784F;
        }
        100%{
            background-color: #50784fa6;
        }
      }
    
    @media only screen and (max-width: $max-tablet-width) {
        .preference-question {
            padding-top: 2rem;
        }
        .preference-question-card {
            h1 {
                font-size: 20px;
            }
        }
        .scroll-point {
            top: -150px;
        }
        .onboarding-heading {
            margin-bottom: 1rem;
        }
        .preference-question-tip {
            width: 240px;
            margin-top: 4rem;
            padding: 1.5rem;
        }
        .question-tip-icon {
            position: absolute;
            top: -15px;
            left: 125px;
        }
    }
</style>
